(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npTabsToggle', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                tabsToggle: '@',
                hasError: '='
            },
            link: function (scope, elem, attrs) {
                var anchorsSelector = '#' + scope.tabsToggle + ' li';
                $(anchorsSelector).click(function (e) {
                    var tab = $(this);
                    if (tab.hasClass("disabled")) {
                        e.preventDefault();
                        return false;
                    }
                    if (tab.hasClass('active')) {
                        window.setTimeout(function () {
                            $(".page-container_content.tab-content > .tab-pane").removeClass('active');
                            //$(".tab-content > .tab-pane").removeClass('active');
                            //$(".tab-pane").removeClass('active');
                            tab.removeClass('active');
                            tab.children('a').blur();
                        }, 1);
                    }
                });
            }
        };
    });

})();